module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point03_04_spectacular_spot-27bb5be01c4c260a32694fba7e5aebbe.jpg";